import { Box, Button, Card, TextField, Typography, Grid, Stack } from "@mui/material";
import { useContext, useState } from "react";
import { FaPen } from "react-icons/fa6";
import { clearNonNumericCharacters, moneyMask, confirmAndExecuteFn } from "../../utils/functions";
import { AiFillGold } from "react-icons/ai";
import PageLayout from "../../components/PageLayout";
import { GoldPriceContext } from "../../providers/GoldPriceProvider";
import { usePermissions } from "../../providers/PermissionsProvider";

export default function PriceManagement() {
    const { currentGoldPrice, updateCurrentGoldPrice, currentSilverPrice, updateCurrentSilverPrice, currentLaborPrice, updateCurrentLaborPrice } = useContext(GoldPriceContext);
    const [goldValue, setGoldValue] = useState(moneyMask(currentGoldPrice));
    const [silverValue, setSilverValue] = useState(moneyMask(currentSilverPrice));
    const [laborValue, setLaborValue] = useState(moneyMask(currentLaborPrice));

    const { verifyPermission } = usePermissions();

    function setGeneralGoldPrice(data) {
        setGoldValue(moneyMask(data));
    };

    function setGeneralSilverPrice(data) {
        setSilverValue(moneyMask(data));
    };

    function setGeneralLaborPrice(data) {
        setLaborValue(moneyMask(data));
    };

    const handleGoldChange = (e) => {
        setGoldValue(moneyMask(e.target.value));
    };

    const handleSilverChange = (e) => {
        setSilverValue(moneyMask(e.target.value));
    };

    const handleLaborChange = (e) => {
        setLaborValue(moneyMask(e.target.value));
    };

    const handleGoldUpdate = () => {
        confirmAndExecuteFn("Tem certeza que deseja atualizar o valor do OURO 24K?", () => {
            updateCurrentGoldPrice(clearNonNumericCharacters(goldValue), setGeneralGoldPrice);
        });
    };

    const handleSilverUpdate = () => {
        confirmAndExecuteFn("Tem certeza que deseja atualizar o valor da PRATA 1000?", () => {
            updateCurrentSilverPrice(clearNonNumericCharacters(silverValue), setGeneralSilverPrice);
        });
    };

    const handleLaborUpdate = () => {
        confirmAndExecuteFn("Tem certeza que deseja atualizar o valor da Mão de Obra?", () => {
            updateCurrentLaborPrice(clearNonNumericCharacters(laborValue), setGeneralLaborPrice);
        });
    };

    const componentName = 'price';

    return (
        <PageLayout pageTitle={"Definição de Cotação Base"} icon={AiFillGold} >
            <Box sx={{ flexGrow: 1, mt: 2 }}>
                <Grid container spacing={3} justifyContent="center">
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={styles.card}>
                            <Box sx={styles.priceContainer}>
                                <Typography variant="h5" color="primary" textAlign="center" mb={".5rem"}>
                                    OURO 24K:
                                </Typography>
                                <Typography variant="h2" fontWeight={600} color="success" textAlign="center">
                                    {moneyMask(currentGoldPrice)}
                                </Typography>
                            </Box>
                            {verifyPermission(componentName, 2) && (
                                <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center" mt={2}>
                                    <TextField
                                        value={goldValue}
                                        onChange={handleGoldChange}
                                        size="small"
                                        placeholder="Escrever novo valor"
                                        sx={styles.textField}
                                    />
                                    <Button
                                        onClick={handleGoldUpdate}
                                        startIcon={<FaPen />}
                                        variant="contained"
                                        color="secondary"
                                        sx={styles.button}
                                    >
                                        Atualizar
                                    </Button>
                                </Stack>
                            )}
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={styles.card}>
                            <Box sx={styles.priceContainer}>
                                <Typography variant="h5" color="primary" textAlign="center" mb={".5rem"}>
                                    PRATA 1000:
                                </Typography>
                                <Typography variant="h2" fontWeight={600} color="success" textAlign="center">
                                    {moneyMask(currentSilverPrice)}
                                </Typography>
                            </Box>
                            {verifyPermission(componentName, 2) && (
                                <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center" mt={2}>
                                    <TextField
                                        value={silverValue}
                                        onChange={handleSilverChange}
                                        size="small"
                                        placeholder="Escrever novo valor"
                                        sx={styles.textField}
                                    />
                                    <Button
                                        onClick={handleSilverUpdate}
                                        startIcon={<FaPen />}
                                        variant="contained"
                                        color="secondary"
                                        sx={styles.button}
                                    >
                                        Atualizar
                                    </Button>
                                </Stack>
                            )}
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card sx={styles.card}>
                            <Box sx={styles.priceContainer}>
                                <Typography variant="h5" color="primary" textAlign="center" mb={".5rem"}>
                                    Mão de Obra
                                </Typography>
                                <Typography variant="h2" fontWeight={600} color="success" textAlign="center">
                                    {moneyMask(currentLaborPrice)}
                                </Typography>
                            </Box>
                            {verifyPermission(componentName, 2) && (
                                <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center" mt={2}>
                                    <TextField
                                        value={laborValue}
                                        onChange={handleLaborChange}
                                        size="small"
                                        placeholder="Escrever novo valor"
                                        sx={styles.textField}
                                    />
                                    <Button
                                        onClick={handleLaborUpdate}
                                        startIcon={<FaPen />}
                                        variant="contained"
                                        color="secondary"
                                        sx={styles.button}
                                    >
                                        Atualizar
                                    </Button>
                                </Stack>
                            )}
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </PageLayout>
    );
};

const styles = {
    card: {
        padding: "1.5rem",
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    priceContainer: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        marginBottom: "1rem",
    },
    textField: {
        width: {
            xs: "100%",
            sm: "auto",
        },
    },
    button: {
        width: {
            xs: "100%",
            sm: "auto",
        },
    },
};
